/* ============================================================
   STRYKR — PDP interactions (Shopify Online Store 2.0)
   IIFE wrapper, no globals. Reads window.STRYKR_PRODUCT injected
   by the section template for variant / cart logic.
   ============================================================ */
(() => {
  'use strict';

  const root = document.querySelector('[data-strykr-main-product], .strykr-page[data-product-id]');
  if (!root) return;

  const P = window.STRYKR_PRODUCT || window.STRYKR_PDP || null;
  const isFrenchLocale = /^\/fr(?:[-/]|$)/.test(window.location.pathname);
  const defaultStrings = isFrenchLocale
    ? {
        addToCart: 'Ajouter au panier',
        soldOut: 'Épuisé',
        unavailable: 'Indisponible',
        selectSize: 'Choisir une taille',
        adding: 'Ajout en cours...',
        added: 'Ajouté au panier',
        error: 'Erreur · réessayez'
      }
    : {
        addToCart: 'In den Warenkorb',
        soldOut: 'Ausverkauft',
        unavailable: 'Nicht verfügbar',
        selectSize: '— bitte Größe wählen',
        adding: 'Wird hinzugefügt…',
        added: 'Hinzugefügt ✓',
        error: 'Fehler · erneut versuchen'
      };
  const germanFallbacks = {
    addToCart: ['In den Warenkorb', 'Jetzt in den Warenkorb'],
    soldOut: ['Ausverkauft'],
    unavailable: ['Nicht verfügbar'],
    selectSize: ['— bitte Größe wählen'],
    adding: ['Wird hinzugefügt…', 'Wird hinzugefügt...'],
    added: ['Hinzugefügt ✓', 'Hinzugefügt'],
    error: ['Fehler · erneut versuchen']
  };
  const getLocaleString = (key) => {
    const source = P && P.strings ? P.strings[key] : '';
    if (!isFrenchLocale) return source || defaultStrings[key] || '';
    if (!source || (germanFallbacks[key] || []).includes(source)) return defaultStrings[key] || '';
    return source;
  };

  const $  = (sel, scope = root) => scope.querySelector(sel);
  const $$ = (sel, scope = root) => Array.from(scope.querySelectorAll(sel));

  const formatMoney = (cents) => {
    if (P && typeof cents === 'number') {
      try {
        return new Intl.NumberFormat(isFrenchLocale ? 'fr-FR' : 'de-DE', {
          style: 'currency',
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
        }).format(cents / 100);
      } catch (_) {}
    }
    return (cents / 100).toFixed(2) + ' €';
  };

  /* =========================================================
     Gallery : thumbs + nav
     ========================================================= */
  const slides = $$('.main-frame .media-slide');
  const thumbs = $$('.thumbs .thumb');

  const activateSlide = (i) => {
    slides.forEach((s, idx) => s.classList.toggle('active', idx === i));
    thumbs.forEach((t, idx) => t.classList.toggle('active', idx === i));
    root.classList.toggle('is-gallery-first', i === 0);
  };

  root.classList.toggle('is-gallery-first', !slides.length || slides[0].classList.contains('active'));

  thumbs.forEach((t) => {
    t.addEventListener('click', () => {
      const i = parseInt(t.dataset.i, 10);
      if (!isNaN(i)) activateSlide(i);
    });
  });

  const galNav = (dir) => {
    if (slides.length < 2) return;
    const current = slides.findIndex((s) => s.classList.contains('active'));
    const next = (current + dir + slides.length) % slides.length;
    activateSlide(next);
  };

  const navLeft  = $('.gal-nav.left');
  const navRight = $('.gal-nav.right');
  if (navLeft)  navLeft.addEventListener('click', () => galNav(-1));
  if (navRight) navRight.addEventListener('click', () => galNav(1));

  /* =========================================================
     Variants : swatches + sizes -> compute matching variant
     ========================================================= */
  const form         = $('#product-form-strykr');
  const nativeProductForm = form && form.closest('product-form');
  const variantInput = $('#variant-id-input');
  const swatchWrap   = $('#swatches');
  const sizeWrap     = $('#sizes');
  const priceNodes   = $$('[data-price]');
  const compareNodes = $$('[data-compare-price]');
  const saveNodes    = $$('[data-save-price]');
  const skuNode      = $('[data-sku]');
  const cta          = $('#cta-main');
  const ctaText      = $('[data-cta-text]', cta || root);
  const colorName    = $('#color-name');
  const sizeName     = $('#size-name');
  const stickyPrice  = $('[data-sticky-price]');
  const stickyCompare = $('[data-sticky-compare-price]');
  const stickyThumb  = $('.sticky .thumb-s img');
  const kachingZone  = $('#strykr-pricing-zone');
  const hasNativeVariantControls = Boolean(form || swatchWrap || sizeWrap);
  const getQuantityToAdd = () => {
    if (!form) return 1;
    const quantityInput = form.querySelector('[name="quantity"]');
    const quantity = Number(quantityInput && quantityInput.value);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  };
  const getCartSectionIds = () => {
    const ids = new Set();
    document.querySelectorAll('cart-items-component').forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        ids.add(item.dataset.sectionId);
      }
    });
    return Array.from(ids);
  };
  const scrollToAnchor = (selector) => {
    if (!selector || selector.charAt(0) !== '#') return false;
    let target = document.querySelector(selector);
    if (!target) return false;

    const isVisibleTarget = (node) => {
      if (!node) return false;
      const rect = node.getBoundingClientRect();
      return rect.width > 0 && rect.height > 20;
    };

    if (selector === '#strykr-pricing-zone') {
      const kachingTarget = Array.from(document.querySelectorAll('kaching-bundles-block, kaching-bundle, .kaching-bundles, [data-kaching-target]'))
        .find(isVisibleTarget);
      target = kachingTarget || target;
    }

    const rect = target.getBoundingClientRect();
    const offset = window.matchMedia('(max-width: 749px)').matches ? 92 : 112;
    const top = Math.max(0, window.pageYOffset + rect.top - offset);
    window.scrollTo({ top, behavior: 'smooth' });
    return true;
  };
  const isDrawerOpen = (drawer) => {
    if (!drawer) return false;
    const dialog = drawer.querySelector('dialog');
    if (dialog) return Boolean(dialog.open || dialog.hasAttribute('open'));
    return drawer.hasAttribute('open') || drawer.classList.contains('open') || drawer.classList.contains('is-open');
  };
  const normalizeOption = (value) => String(value || '').trim().toLowerCase();
  const parseJsonAttribute = (node, attr) => {
    if (!node) return null;
    try {
      return JSON.parse(node.getAttribute(attr) || 'null');
    } catch (_) {
      return null;
    }
  };
  const getKachingBlock = () => kachingZone && kachingZone.querySelector('kaching-bundles-block');
  const getKachingDealBlock = () => parseJsonAttribute(getKachingBlock(), 'deal-block') || {};
  const getKachingProduct = () => parseJsonAttribute(getKachingBlock(), 'product') || {};

  const getSelectedKachingDeal = () => {
    const dealBlock = getKachingDealBlock();
    const checked = kachingZone && kachingZone.querySelector('input[type="radio"][name^="kaching-bundles-deal"]:checked');
    const selectedId = checked && checked.value ? checked.value : dealBlock.preselectedDealBarId;
    if (!selectedId || !Array.isArray(dealBlock.dealBars)) return null;
    return dealBlock.dealBars.find((deal) => String(deal.id) === String(selectedId)) || null;
  };

  const syncQuantityFromKaching = () => {
    const selectedDeal = getSelectedKachingDeal();
    const quantity = Number(selectedDeal && selectedDeal.quantity);
    const quantityInput = form && form.querySelector('[name="quantity"]');
    if (quantityInput && Number.isFinite(quantity) && quantity > 0) {
      quantityInput.value = String(quantity);
      return quantity;
    }
    return getQuantityToAdd();
  };

  const getKachingSelectedOptions = () => {
    if (!kachingZone) return [];
    const product = getKachingProduct();
    const optionNames = Array.isArray(product.options)
      ? product.options.map((option) => option && (option.name || option.defaultName)).filter(Boolean)
      : [];
    const selects = Array.from(kachingZone.querySelectorAll('select.kaching-bundles-option, .kaching-bundles__bar-variant-select'));
    if (!selects.length) return [];

    if (optionNames.length) {
      const selectedByName = new Map();
      selects.forEach((select) => {
        const name = select.dataset && select.dataset.name;
        if (!name) return;
        const normalizedName = normalizeOption(name);
        if (!selectedByName.has(normalizedName)) selectedByName.set(normalizedName, select.value);
      });
      const ordered = optionNames.map((name) => selectedByName.get(normalizeOption(name)));
      if (ordered.every(Boolean)) return ordered;
    }

    return selects.slice(0, optionNames.length || selects.length).map((select) => select.value).filter(Boolean);
  };

  const syncVariantFromKaching = () => {
    if (!variantInput || !kachingZone) return null;
    const product = getKachingProduct();
    const selectedOptions = getKachingSelectedOptions();
    if (!selectedOptions.length || !Array.isArray(product.variants)) return null;
    const variant = product.variants.find((candidate) => {
      const options = candidate && Array.isArray(candidate.options) ? candidate.options : [];
      if (options.length < selectedOptions.length) return false;
      return selectedOptions.every((option, index) => normalizeOption(options[index]) === normalizeOption(option));
    });
    if (variant && variant.id) {
      variantInput.value = String(variant.id);
      return variant;
    }
    return null;
  };

  const prepareKachingSelection = () => {
    syncVariantFromKaching();
    return syncQuantityFromKaching();
  };

  const ensureCartDrawerElement = () => {
    if (!window.customElements || window.customElements.get('cart-drawer')) return;

    if (typeof window.removeTrapFocus !== 'function') window.removeTrapFocus = () => {};
    if (typeof window.trapFocus !== 'function') window.trapFocus = () => {};

    window.customElements.define('cart-drawer', class CartDrawer extends HTMLElement {
      connectedCallback() {
        if (this.dataset.strykrDrawerReady === 'true') return;
        this.dataset.strykrDrawerReady = 'true';
        const overlay = this.querySelector('#CartDrawer-Overlay, .cart-drawer__overlay');
        if (overlay) overlay.addEventListener('click', () => this.close());
      }

      open() {
        this.classList.add('active');
        document.body.classList.add('overflow-hidden');
        const inner = this.querySelector('.drawer__inner');
        if (inner && typeof inner.focus === 'function') {
          window.setTimeout(() => inner.focus(), 80);
        }
      }

      close() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
    });
  };

  const sectionUrl = (sectionIds) => {
    const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const url = new URL(rootPath, window.location.origin);
    url.searchParams.set('sections', sectionIds.join(','));
    return url.toString();
  };

  const replaceSectionHTML = (sectionId, html) => {
    if (!html) return;
    const current = document.getElementById(`shopify-section-${sectionId}`);
    const next = new DOMParser().parseFromString(html, 'text/html').getElementById(`shopify-section-${sectionId}`);
    if (current && next) current.innerHTML = next.innerHTML;
  };

  const refreshCartDrawerSections = async () => {
    try {
      const response = await fetch(sectionUrl(['cart-drawer', 'cart-icon-bubble']), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) return;
      const sections = await response.json();
      replaceSectionHTML('cart-drawer', sections['cart-drawer']);
      replaceSectionHTML('cart-icon-bubble', sections['cart-icon-bubble']);
      ensureCartDrawerElement();
    } catch (_) {}
  };

  const state = {
    color: swatchWrap ? (($('.sw.active', swatchWrap) || {}).dataset || {}).value || null : null,
    size:  sizeWrap   ? (($('.size.active', sizeWrap)  || {}).dataset || {}).value || null : null,
  };

  const findVariant = () => {
    if (!P || !P.variants) return null;
    const colorIdx = swatchWrap ? parseInt(swatchWrap.dataset.optionIndex, 10) : -1;
    const sizeIdx  = sizeWrap   ? parseInt(sizeWrap.dataset.optionIndex, 10)   : -1;
    return P.variants.find((v) => {
      const opts = v.options || [];
      const colorOk = colorIdx < 0 || state.color == null || opts[colorIdx] === state.color;
      const sizeOk  = sizeIdx  < 0 || state.size  == null || opts[sizeIdx]  === state.size;
      return colorOk && sizeOk;
    }) || null;
  };

  const updateSizeAvailability = () => {
    if (!sizeWrap || !P) return;
    const colorIdx = swatchWrap ? parseInt(swatchWrap.dataset.optionIndex, 10) : -1;
    const sizeIdx  = parseInt(sizeWrap.dataset.optionIndex, 10);
    $$('.size', sizeWrap).forEach((btn) => {
      const sizeValue = btn.dataset.value;
      const has = P.variants.some((v) => {
        const opts = v.options || [];
        if (colorIdx >= 0 && state.color && opts[colorIdx] !== state.color) return false;
        return opts[sizeIdx] === sizeValue && v.available;
      });
      btn.classList.toggle('oos', !has);
      if (has) btn.removeAttribute('aria-disabled');
      else btn.setAttribute('aria-disabled', 'true');
    });
  };

  const updatePrice = (variant) => {
    if (!variant) return;
    const priceText = variant.priceFormatted || formatMoney(variant.price);
    priceNodes.forEach((n) => { n.textContent = priceText; });
    if (stickyPrice) stickyPrice.textContent = priceText;

    compareNodes.forEach((n) => {
      if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
        n.textContent = variant.compareAtPriceFormatted || formatMoney(variant.compareAtPrice);
        n.style.display = '';
      } else {
        n.style.display = 'none';
      }
    });
    if (stickyCompare) {
      if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
        stickyCompare.textContent = variant.compareAtPriceFormatted || formatMoney(variant.compareAtPrice);
        stickyCompare.style.display = '';
      } else {
        stickyCompare.style.display = 'none';
      }
    }

    saveNodes.forEach((n) => {
      if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
        n.textContent = formatMoney(variant.compareAtPrice - variant.price);
        n.style.display = '';
      } else {
        n.style.display = 'none';
      }
    });

    if (skuNode && variant.sku) skuNode.textContent = 'SKU · ' + variant.sku;
  };

  const updateAvailability = (variant) => {
    if (!cta || !ctaText) return;
    if (!variant) {
      cta.setAttribute('disabled', '');
      ctaText.textContent = getLocaleString('unavailable');
      return;
    }
    if (variant.available) {
      cta.removeAttribute('disabled');
      ctaText.textContent = getLocaleString('addToCart');
    } else {
      cta.setAttribute('disabled', '');
      ctaText.textContent = getLocaleString('soldOut');
    }
  };

  const updateURL = (variant) => {
    if (!variant) return;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url.toString());
    } catch (_) {}
  };

  const updateFeaturedMedia = (variant) => {
    if (!variant || !variant.featuredMediaId) return;
    const target = slides.find((s) => String(s.dataset.mediaId) === String(variant.featuredMediaId));
    if (target) {
      const i = parseInt(target.dataset.i, 10);
      if (!isNaN(i)) activateSlide(i);
    }
    if (stickyThumb && variant.featuredMediaThumbUrl) {
      stickyThumb.src = variant.featuredMediaThumbUrl;
    }
  };

  const syncVariant = () => {
    const variant = findVariant();
    if (variantInput && variant) variantInput.value = variant.id;
    updatePrice(variant || (P && P.variants && P.variants[0]));
    updateAvailability(variant);
    updateURL(variant);
    updateFeaturedMedia(variant);
  };

  if (swatchWrap) {
    $$('.sw', swatchWrap).forEach((btn) => {
      btn.addEventListener('click', () => {
        $$('.sw', swatchWrap).forEach((x) => {
          x.classList.remove('active');
          x.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
        state.color = btn.dataset.value;
        if (colorName) colorName.textContent = state.color;
        updateSizeAvailability();
        syncVariant();
      });
    });
  }

  if (sizeWrap) {
    $$('.size', sizeWrap).forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('oos')) return;
        $$('.size', sizeWrap).forEach((x) => x.classList.remove('active'));
        btn.classList.add('active');
        state.size = btn.dataset.value;
        if (sizeName) {
          sizeName.textContent = state.size;
          sizeName.style.color = '';
        }
        syncVariant();
      });
    });
  }

  if (hasNativeVariantControls) {
    updateSizeAvailability();
    syncVariant();
  }

  /* =========================================================
     ATC via /cart/add.js (fetch, no reload)
     ========================================================= */
  const openCart = async () => {
    ensureCartDrawerElement();
    await refreshCartDrawerSections();

    const standardDrawer = document.querySelector('cart-drawer');
    if (standardDrawer && typeof standardDrawer.open === 'function') {
      standardDrawer.classList.remove('is-empty');
      standardDrawer.open();
      return;
    }

    const existingDrawer = document.querySelector('cart-drawer-component');
    if (existingDrawer && window.customElements && typeof window.customElements.whenDefined === 'function') {
      try {
        await Promise.race([
          window.customElements.whenDefined('cart-drawer-component'),
          new Promise((resolve) => window.setTimeout(resolve, 180))
        ]);
      } catch (_) {}
    }

    const horizonDrawer = document.querySelector('cart-drawer-component');
    if (horizonDrawer && typeof horizonDrawer.open === 'function') {
      horizonDrawer.open();
      await new Promise((resolve) => window.setTimeout(resolve, 160));
      if (isDrawerOpen(horizonDrawer)) return;
    }
    if (horizonDrawer && typeof horizonDrawer.showDialog === 'function' && !isDrawerOpen(horizonDrawer)) {
      horizonDrawer.showDialog();
      await new Promise((resolve) => window.setTimeout(resolve, 160));
      if (isDrawerOpen(horizonDrawer)) return;
    }

    const themeDrawer = document.querySelector('cart-drawer, cart-notification');
    if (themeDrawer && typeof themeDrawer.open === 'function') {
      themeDrawer.open();
      return;
    }
  };

  const refreshCartCount = async ({ sections, quantityAdded } = {}) => {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count], .cart-count-bubble span, #cart-count').forEach((el) => {
        el.textContent = String(cart.item_count);
        try {
          el.animate(
            [{ transform: 'scale(1)' }, { transform: 'scale(1.4)' }, { transform: 'scale(1)' }],
            { duration: 300 }
          );
        } catch (_) {}
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: variantInput && variantInput.value ? String(variantInput.value) : 'product-form-strykr',
          data: {
            source: 'product-form-component',
            productId: P && P.id ? String(P.id) : '',
            variantId: variantInput && variantInput.value ? String(variantInput.value) : '',
            itemCount: quantityAdded || getQuantityToAdd(),
            sections: sections || undefined
          }
        }
      }));
      return cart;
    } catch (_) {
      return null;
    }
  };

  const buildCartPayload = () => {
    prepareKachingSelection();
    const formData = new FormData(form);
    const properties = {};
    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') properties[match[1]] = value;
    }

    const item = {
      id: Number(formData.get('id')),
      quantity: Number(formData.get('quantity')) || getQuantityToAdd()
    };
    if (Object.keys(properties).length) item.properties = properties;
    if (formData.get('selling_plan')) item.selling_plan = formData.get('selling_plan');

    return { items: [item] };
  };

  const isolatedCartAdd = async (payload) => {
    const frame = document.createElement('iframe');
    frame.setAttribute('aria-hidden', 'true');
    frame.tabIndex = -1;
    frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
    document.body.appendChild(frame);

    try {
      const nativeFetch = frame.contentWindow.fetch.bind(frame.contentWindow);
      const response = await nativeFetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      });
      const text = await response.text();
      const json = text ? JSON.parse(text) : {};
      if (!response.ok) throw new Error(json.description || json.message || response.statusText);
      return json;
    } finally {
      frame.remove();
    }
  };

  const addToCart = async () => {
    if (!form || !variantInput || !variantInput.value) return;

    if (sizeWrap && !$('.size.active', sizeWrap)) {
      if (sizeName) {
        sizeName.textContent = getLocaleString('selectSize');
        sizeName.style.color = 'var(--alert)';
      }
      try {
        sizeWrap.animate(
          [{ transform: 'translateX(0)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' }, { transform: 'translateX(0)' }],
          { duration: 250 }
        );
      } catch (_) {}
      return;
    }

    if (ctaText) ctaText.textContent = getLocaleString('adding');
    cta.setAttribute('disabled', '');

    try {
      const payload = buildCartPayload();
      const added = await isolatedCartAdd(payload);
      const quantityAdded = payload.items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0) || getQuantityToAdd();
      if (ctaText) ctaText.textContent = getLocaleString('added');
      try {
        cta.animate(
          [{ background: 'var(--tac)' }, { background: '#1F8A4C' }, { background: 'var(--tac)' }],
          { duration: 500 }
        );
      } catch (_) {}
      await refreshCartCount({ sections: added.sections, quantityAdded });
      document.dispatchEvent(new CustomEvent('cart:added', { detail: added }));
      if (ctaText) ctaText.textContent = getLocaleString('addToCart');
      cta.removeAttribute('disabled');
      await openCart();
    } catch (e) {
      if (ctaText) ctaText.textContent = getLocaleString('error');
      setTimeout(() => {
        if (ctaText) ctaText.textContent = getLocaleString('addToCart');
        cta.removeAttribute('disabled');
      }, 1500);
    }
  };

  if (form) {
    if (nativeProductForm) {
      form.addEventListener('submit', () => {
        prepareKachingSelection();
      }, true);
    } else {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        window.setTimeout(addToCart, 0);
      });
    }

    form.addEventListener('change', (event) => {
      if (!kachingZone || !kachingZone.contains(event.target)) return;
      window.setTimeout(prepareKachingSelection, 80);
    });
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-strykr-scroll], a[href="#strykr-pricing-zone"], a[href$="#strykr-pricing-zone"]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    const targetUrl = new URL(href || window.location.href, window.location.href);
    if (!href.startsWith('#') && targetUrl.pathname !== window.location.pathname) return;
    const hash = href.startsWith('#') ? href : targetUrl.hash;
    if (hash !== '#strykr-pricing-zone' && !link.hasAttribute('data-strykr-scroll')) return;
    if (!scrollToAnchor(hash)) return;
    event.preventDefault();
  });

  /* =========================================================
     Delivery date range (J+6 to J+8 business days, DACH)
     ========================================================= */
  const deliveryDate = $('#delivery-date');
  if (deliveryDate) {
    const days   = ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];
    const months = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
    const addBusinessDays = (date, businessDays) => {
      const next = new Date(date);
      let added = 0;
      while (added < businessDays) {
        next.setDate(next.getDate() + 1);
        if (![0, 6].includes(next.getDay())) added += 1;
      }
      return next;
    };
    const formatDate = (date) => `${days[date.getDay()]}, ${date.getDate()}. ${months[date.getMonth()]}`;
    const earliest = addBusinessDays(new Date(), 6);
    const latest = addBusinessDays(new Date(), 8);
    deliveryDate.textContent = `zwischen ${formatDate(earliest)} und ${formatDate(latest)}`;
  }

  /* =========================================================
     Sticky ATC visibility on scroll
     ========================================================= */
  const sticky = $('#sticky');
  const hero   = $('.hero');
  if (sticky && hero && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      ([e]) => sticky.classList.toggle('show', !e.isIntersecting),
      { rootMargin: '-80% 0px 0px 0px' }
    );
    io.observe(hero);
  }
})();
